import React from "react";
import { RECOMMENDED_QUANTITIES } from "utils/constants";
import Dropdown from "components/dropdown";
import clsx from "clsx/lite";

const RecommendedQuantityButtons = ({ quantity, setQuantity }) => (
	<>
		{RECOMMENDED_QUANTITIES.map((i) => (
			<button
				key={i}
				className={
					clsx("border whitespace-nowrap w-1/4 py-2.5 text-secondary text-center md:uppercase",
						quantity === i ? "bg-seashell border-sunray !text-primary" : "bg-white")}
				onClick={() => setQuantity(i)}
			>
				{i} Qty
			</button>
		))}
	</>
);

const CustomQuantityDropdown = ({ quantity, setQuantity, isRecommended, isCustomDefaultValue }) => {
	const initialQuantity = isCustomDefaultValue && !quantity ? 2 : quantity;

	//Use isCustomDefaultValue to display the quantity dropdown with options from 1 to 30 and keeping all recommended quantities
	return (
		isCustomDefaultValue ?
			<Dropdown
				Preview={() => <span className="ml-4">{initialQuantity}</span>}
				className="text-secondary w-full"
				activeClass="py-2.5"
				value={initialQuantity}
				onChange={(e) => setQuantity(e.target.value === "Custom" ? 1 : +e.target.value)}
			>

				{new Array(30).fill(0).map((_, i) => (
					<option key={i + 1} value={i + 1}>{i + 1}</option>
				))}
			</Dropdown> :
			<Dropdown
				Preview={() => <span className="mx-auto">{!isRecommended ? `${quantity} Qty` : "Custom"}</span>}
				className="w-1/4 text-secondary bg-white"
				activeClass={clsx("py-2.5", !isRecommended ? "text-primary bg-seashell border border-sunray" : "")}
				value={initialQuantity}
				hideArrow
				onChange={(e) => setQuantity(e.target.value === "Custom" ? 1 : +e.target.value)}
			>

				<option value="Custom" className="text-secondary bg-white">Custom</option>
				{new Array(28).fill(0).map((_, i) => (
					RECOMMENDED_QUANTITIES.includes(i + 3) ? null :
						<option key={i + 3} value={i + 3}>{i + 3} Qty</option>
				))}

			</Dropdown>
	);
};

const QuantityPicker = ({ config, isCustomDefaultValue = false }) => {
	const { quantity, setQuantity } = config || {};
	const isRecommended = RECOMMENDED_QUANTITIES.includes(quantity);

	return (
		<div>
			{config?.template === "recommended" || isCustomDefaultValue ? (
				<div className="flex gap-3">
					{!isCustomDefaultValue && <RecommendedQuantityButtons quantity={quantity} setQuantity={setQuantity} />}
					<CustomQuantityDropdown quantity={quantity} setQuantity={setQuantity}
						isRecommended={isRecommended} isCustomDefaultValue={isCustomDefaultValue} />
				</div>
			) : (
				<div className="flex flex-col gap-2 border w-fit bg-white">
					<div className="flex items-center *:py-1.5 *:px-4">
						<button className="default-quanity-btn" onClick={() => quantity > 1 && setQuantity(quantity - 1)}>
							-
						</button>
						<span>{quantity}</span>
						<button className="default-quanity-btn" onClick={() => setQuantity(quantity + 1)}>
							+
						</button>
					</div>
				</div>
			)}
		</div>
	);
};

export default QuantityPicker;